import { inlineToolbarTabs } from '../../inline';
import { BlockToolbarComponent, InlineToolbarComponent } from './components';
export var orderedListBlock = {
  blockToolbarComponent: BlockToolbarComponent,
  inlineToolbarComponent: InlineToolbarComponent,
  inlineToolbarTabs: inlineToolbarTabs,
  isEditable: false
};